import { render, staticRenderFns } from "./ReportStats.vue?vue&type=template&id=5d6e0ef8&"
import script from "./ReportStats.vue?vue&type=script&lang=js&"
export * from "./ReportStats.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5d6e0ef8')) {
      api.createRecord('5d6e0ef8', component.options)
    } else {
      api.reload('5d6e0ef8', component.options)
    }
    module.hot.accept("./ReportStats.vue?vue&type=template&id=5d6e0ef8&", function () {
      api.rerender('5d6e0ef8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "public/js/src/app/components/purchase-activity-flash/reports/ReportStats.vue"
export default component.exports